import React from "react"
import { createContext, useState } from "react"
import { useQuery, useMutation, gql } from '@apollo/client'
import { useCookies } from 'react-cookie'
import { useCsEvent } from "../client/useEvents"

const loggedInContext = createContext({});

const gqlQuery = gql`
  query me {
    me {
      id,
      username,
      patreon_id,
      abonelik,
      collections {
        id,
        title
      },
      viewLimit {
        left
        resetAt
      }
    }
  }
`
const patreonSilMutation = gql`
  mutation PatreonSil {
    patreonSil
  }
`

const LoggedInContextProvider = ({ children }) => {
  const [cookies, setCookie] = useCookies(['login_cookie'])
  const [loggedIn, setLoggedIn] = useState(false)
  const [user, setUser] = useState(null)
  const [isLoginOpen, setLoginOpen] = useState(false)
  const [isSignupOpen, setSignupOpen] = useState(false)
  const [loginCta, setLoginCta] = useState(null)
  const fireCsEvent = useCsEvent()
  
  let { data, refetch, loading } = useQuery(gqlQuery, {ssr: false})

  const [patreonSilTrigger, 
    {called: patreonSilCalled, 
      loading: patreonSilLoading, 
      data: patreonSilData, 
      error: patreonSilError}
  ] = useMutation(patreonSilMutation, {
    onCompleted: (data) => {
      //set login cookie on success
      if (data?.patreonSil) {
        console.info("Patreon sil completed")
        refetch()
      }
    },
    errorPolicy: 'all'
  })

  console.debug("[LoggedInContextProvider]", "loading:", loading, 
    "me:", data?.me)
  
  if (data?.me !== user) {
    console.debug("User değişti, state update yap")
    setLoggedIn(!!data?.me)
    setUser(data?.me)
  }

  const openLoginModal = (cta) => {
    setLoginOpen(true)
    setSignupOpen(false)
    if (cta) {
      setLoginCta(cta)
    }
    fireCsEvent({
      category: "User",
      action: "Engagement",
      label: "Login modal acildi"
    })
  }

  const openSignupModal = () => {
    setLoginOpen(false)
    setSignupOpen(true)
    fireCsEvent({
      category: "User",
      action: "Engagement",
      label: "Signup modal acildi"
    })
  }

  const closeAllModals = () => {
    setLoginOpen(false)
    setSignupOpen(false)
    setLoginCta(null)
  }

  const logIn = (token) => {
    setCookie('login_cookie', token, {path: '/', maxAge: 3600*24*30})
    setLoggedIn(true)
    refetch()
  }

  const logOut = () => {
    setCookie('login_cookie', '', {path: '/', maxAge: 3600*24*30})
    setLoggedIn(false)
    setUser(null)
    refetch()
  }

  const patreonHesabiSil = () => {
    patreonSilTrigger()
  }

  return (
    <loggedInContext.Provider 
      value={{ loggedIn, setLoggedIn, 
        loginCta, setLoginCta,
        user, loading,
        logIn, logOut, patreonHesabiSil,
        isLoginOpen, isSignupOpen, openLoginModal, 
        openSignupModal, closeAllModals 
      }}>
      {children}
    </loggedInContext.Provider>
  );
};

export { loggedInContext, LoggedInContextProvider }
